import { axios } from '@Root/API'

export const getAll = (engagementInd, params) => {
	return axios.get(`student-engagement/${engagementInd}/student-initiative`, { params })
}
